import cx from 'classnames';
import React from 'react';
import { Link } from '../../link';
import styles from './pagination-range.module.scss';
export const PaginationRange = ({ batchOffset, batchSize, isFirstDisabled = true, isNextDisabled = false, onBatchOffsetChange, children, firstText, previousText, nextText, onFirstPage, onPreviousPage, onNextPage, }) => {
    const isPrevDisabled = batchOffset < batchSize;
    const onFirst = (e) => {
        if (onFirstPage) {
            onFirstPage();
        }
        else if (onBatchOffsetChange && !isFirstDisabled) {
            onBatchOffsetChange(0);
        }
        e.preventDefault();
    };
    const onKeyFirst = (e) => {
        if (e.which === 13) {
            onFirst(e);
        }
    };
    const onPrevious = (e) => {
        if (onPreviousPage) {
            onPreviousPage();
        }
        else if (onBatchOffsetChange && !isPrevDisabled) {
            onBatchOffsetChange(batchOffset - batchSize);
        }
        e.preventDefault();
    };
    const onKeyPrevious = (e) => {
        if (e.which === 13) {
            onPrevious(e);
        }
    };
    const onNext = (e) => {
        if (onNextPage) {
            onNextPage();
        }
        else if (onBatchOffsetChange && !isNextDisabled) {
            onBatchOffsetChange(batchOffset + batchSize);
        }
        e.preventDefault();
    };
    const onKeyNext = (e) => {
        if (e.which === 13) {
            onNext(e);
        }
    };
    const firstNavStyles = cx(styles.paginationBlock, styles.firstNav);
    return (React.createElement("nav", null,
        React.createElement("div", { className: styles.paginationList },
            !isFirstDisabled && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            React.createElement(Link, { tabIndex: 0, disabled: isFirstDisabled, onClick: onFirst, onKeyDown: (e) => {
                    onKeyFirst(e);
                }, className: firstNavStyles, "data-testid": "pagination-range-first-page" }, `<< ${firstText}`)),
            !isPrevDisabled && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            React.createElement(Link, { tabIndex: 0, disabled: isPrevDisabled, onClick: onPrevious, onKeyDown: (e) => {
                    onKeyPrevious(e);
                }, className: styles.paginationBlock, "data-testid": "pagination-range-previous-page" }, `< ${previousText}`)),
            React.createElement("div", { className: styles.rangeInfo }, children),
            !isNextDisabled && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            React.createElement(Link, { tabIndex: 0, disabled: isNextDisabled, onClick: onNext, onKeyDown: (e) => {
                    onKeyNext(e);
                }, className: styles.paginationBlock, "data-testid": "pagination-range-next-page" }, `${nextText} >`)))));
};
//# sourceMappingURL=pagination-range.js.map